mutation CreateEvent($name: String!, $description: String) {
  event: StreamToolsCreateEvent(name: $name, description: $description) {
    eventId
    slug
    name
    description
    status
    createdAt
  }
}
